import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardBody from "../../shared/RoomCardBody/RoomCardBody"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import Wrapper from "../../shared/Wrapper/Wrapper"

import "./Occupied.css"
import { useElapsedTime } from "src/shared/hooks/useElapsedTime"
import { useDate } from "src/shared/hooks/useDate"
import { useTimePulse } from "src/shared/hooks/useTimePulse"
import Icon from "src/shared/icons"
import useMinuteTimer from "src/shared/hooks/useMinuteTimer"
import { formatTime } from "src/shared/utils/formatTime"
import getOccupiedStatus from "../../../../helpers/getOccuppiedStatus"
import { MainTimerValue, rsTimerValue } from "../../../../helpers/getOccuppiedStatus.type"
import getFirstConceptoPendiente from "../../../../helpers/getFirstConceptoPendiente"
import { useMaxWidthContext } from "../../../hooks/useMaxWidth"

const Occupied = ({
    roomTypeName,
    roomNumber,
    hasIncidences,
    occupiedTimeEndCondensada = "",
    roomServiceTimeEnd = "",
    occupiedTimeEnd = "",
    placas,
    lastRentStatus,
    easyrewards,
    ultimaOrden,
    fecha_antigua_por_entregar,
    room,
}: RoomStatusProps) => {
    const [now] = useTimePulse()

    const { UTCStringToLocalDate } = useDate()
    const { older } = getFirstConceptoPendiente(room?.ultima_renta?.ultimos_conceptos_pendientes)
    const { maxWidth } = useMaxWidthContext()

    const status = getOccupiedStatus({
        now,
        occupiedTimeEndCondensada,
        ultimaOrden,
        ultimos_conceptos_pendientes: room?.ultima_renta?.ultimos_conceptos_pendientes,
        occupiedTimeEnd,
        roomNumber,
        olderConceptoPendiente: older,
        fecha_antigua_por_entregar,
    })

    const itemHeight = "20cqh"

    const [occuppiedElapsedTime] = useElapsedTime(
        UTCStringToLocalDate(occupiedTimeEndCondensada),
        "noche",
        room?.ultima?.renta?.estado === "pendiente_pago"
    )

    const [timePagoPendiente] = useElapsedTime(
        older?.date ? older.date : UTCStringToLocalDate(occupiedTimeEndCondensada),
        "noche",
        room?.ultima?.renta?.estado !== "pendiente_pago"
    )

    const { timeValue: orderTimer } = useMinuteTimer({
        timeStartUTC: fecha_antigua_por_entregar
            ? fecha_antigua_por_entregar
            : ultimaOrden?.orden?.fecha_registro || "",
    })

    return (
        <Wrapper
            bgColor="var(--pink-ocupado-light)"
            alertBgColor1={status?.alert ? "var(--ocupada-card-1)" : null}
            alertBgColor2={status?.alert ? "var(--pink-ocupado-light)" : null}
            hasIncidences={hasIncidences}
        >
            <RoomCardHeader
                iconName={status?.icon || "BedFilled"}
                roomNumber={roomNumber}
                hasIncidences={hasIncidences}
                iconBgColor="var(--pink-ocupado)"
                roomTypeAbbreviation={roomTypeName[0]}
                iconBgSecondaryColor="var(--pink-ocupado)"
                easyrewards={easyrewards}
            />
            <RoomCardBody>
                <div className="room-card--xs--occupied__description_wrapper" style={{ maxWidth }}>
                    {status?.rsTimer !== rsTimerValue.NA ? (
                        <span
                            className={
                                status?.rsTimer === rsTimerValue.ASCExcedido
                                    ? "room-card--xs--occupied__timer--timeout"
                                    : "room-card--xs--occupied__timer"
                            }
                            style={{ fontSize: itemHeight }}
                        >
                            {formatTime({ time: orderTimer, withHours: true })}
                        </span>
                    ) : status?.mainTimer === MainTimerValue.rentaASC ? (
                        <span className="room-card--xs--occupied__timer--timeout" style={{ fontSize: itemHeight }}>
                            +{occuppiedElapsedTime}
                        </span>
                    ) : (
                        <span
                            className={
                                status?.mainTimer === MainTimerValue.payASC && status?.alert
                                    ? "room-card--xs--occupied__timer--timeout"
                                    : "room-card--xs--occupied__timer"
                            }
                            style={{ fontSize: itemHeight }}
                        >
                            {status?.mainTimer === MainTimerValue.payASC ? timePagoPendiente : occuppiedElapsedTime}
                        </span>
                    )}
                    <span className="room-card--xs--occupied__description" style={{ fontSize: itemHeight }}>
                        <Icon
                            name={placas ? "car" : "walking"}
                            height={itemHeight}
                        />
                        &nbsp;
                        {placas ? placas : "A pie"}
                    </span>
                </div>
            </RoomCardBody>
        </Wrapper>
    )
}

export default Occupied
